module.exports = __webpack_public_path__ + "assets/images/map_small_en.svg";